import { Location } from "history";
import { ReactComponentElement } from "react";
import { NavLink } from "react-router-dom";

import { Box, useTheme } from "@seneca/senekit";

import styles from "../AssignmentRow.module.scss";

type Props = {
  linkToStartSession: Location | null;
  active?: boolean;
  children: {
    count: ReactComponentElement<any, any>;
    scoreIndicator?: ReactComponentElement<any, any>;
  };
};

export default function AssignmentExamQuestionsRow({
  active,
  linkToStartSession,
  children: { count, scoreIndicator }
}: Props) {
  const theme = useTheme();

  return !!linkToStartSession ? (
    <NavLink to={linkToStartSession as Location} className={styles.link}>
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        borderRadius="small"
        background={active ? theme["primary-low-surface"] : undefined}
        hoverStyles={{
          background: theme["primary-low-surface"]
        }}
        alignItems="center"
      >
        {count}
        {scoreIndicator}
      </Box>
    </NavLink>
  ) : (
    <Box
      width="100%"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      borderRadius="small"
      alignItems="center"
    >
      {count}
      {scoreIndicator}
    </Box>
  );
}
